import withSpacing from '../../decorators/withSpacing/index';
import TextField from './TextField';
export default withSpacing(TextField);
//# sourceMappingURL=index.js.map